/*通用类库*/
import {
	ajaxGet,
	ajaxPost
} from '@/utils/request';
import {
	setStorage,
	getStorage
} from '@/utils/storagehelper';
import {
	getAccountInfo
} from '@/utils/localdatas';

// 测试用户配置（默认展示用）
// Test user configuration (for default display)
// 只在开发环境使用，生产环境应通过环境变量配置
const getTestUserConfig = () => {
	// 生产环境不应该使用测试用户
	if (process.env.NODE_ENV === 'production') {
		return null
	}
	let testAccountID='CMC0MU04';
	// 开发环境可以使用环境变量或默认值
	return {
		BookerID: process.env.VUE_APP_TEST_BOOKER_ID || testAccountID,
		Account: process.env.VUE_APP_TEST_ACCOUNT || testAccountID,
		useraccountno: process.env.VUE_APP_TEST_BOOKER_ID || testAccountID,
		LoginName: process.env.VUE_APP_TEST_ACCOUNT || testAccountID,
		CompanyCode: '',
		CompanyName: '测试用户',
		RoleID: 0,
		userRoleID: 0,
		OrganizaType: 'INCU',
		userOrganizaType: 'INCU',
		Name: '测试用户',
		Mobile: '13800138000',
		Email: 'test@example.com',
		UserHeadImg: ''
	}
}

const TEST_USER_CONFIG = getTestUserConfig()

import router from '@/router'

var webconfig = require('@/utils/webconfig.js');


var YqfSessionKey = "_yqfSessionKey_fhpc";

export var mpid = "26"; //对应的公众号ID
export var apiUrl = webconfig.apiurl;
export var yqfApiurl = webconfig.yqfApiurl;
export var uploadDomain = webconfig.uploadDomain;
export var mapApiUrl = webconfig.mapApiUrl;

export function formatTime(date) {
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var day = date.getDate();

	var hour = date.getHours();
	var minute = date.getMinutes();
	var second = date.getSeconds();
	return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

export function formatNumber(n) {
	n = n.toString()
	return n[1] ? n : '0' + n
}

export function isNullOrEmpty(obj) {
	return obj == null || obj == '' || obj == undefined || obj == "null";
}
//唯一标识
export function newGuid() {
	var guid = "";
	for (var i = 1; i <= 32; i++) {
		var n = Math.floor(Math.random() * 16.0).toString(16);
		guid += n;
		if ((i == 8) || (i == 12) || (i == 16) || (i == 20))
			guid += "-";
	}
	return guid;
}
export function checkLogin() {
	return getAccountInfo() != null;
}

/**
 * 获取用户信息（带测试用户fallback）
 * @returns {Object|null} 用户信息对象，如果未登录则返回测试用户配置
 */
export function getUserInfo() {
	const accountInfo = getAccountInfo()
	if (accountInfo) {
		return accountInfo
	}
	// Return test user configuration if not logged in (only in development)
	if (process.env.NODE_ENV !== 'production' && TEST_USER_CONFIG) {
		return TEST_USER_CONFIG
	}
	return null
}

/**
 * 获取BookerID（优先登录用户，否则使用测试用户）
 * @param {string} [fallbackBookerId] - 可选的fallback BookerID
 * @returns {string} BookerID
 */
export function getBookerID(fallbackBookerId) {
	const accountInfo = getAccountInfo()
	if (accountInfo) {
		// 优先使用 useraccountno，然后是 Account，最后是 LoginName
		return accountInfo.useraccountno || 
		       accountInfo.Account || 
		       accountInfo.LoginName || 
		       accountInfo.ACNumber ||
		       fallbackBookerId || ''
	}
	// Use test user only in development, otherwise use fallback
	if (process.env.NODE_ENV !== 'production' && TEST_USER_CONFIG && TEST_USER_CONFIG.BookerID) {
		return fallbackBookerId || TEST_USER_CONFIG.BookerID
	}
	return fallbackBookerId || ''
}

/**
 * 获取用户账号（优先登录用户，否则使用测试用户）
 * @returns {string} 用户账号
 */
export function getUserAccount() {
	const accountInfo = getAccountInfo()
	if (accountInfo) {
		return accountInfo.useraccountno || 
		       accountInfo.Account || 
		       accountInfo.LoginName || 
		       accountInfo.ACNumber || ''
	}
	// Use test user only in development
	if (process.env.NODE_ENV !== 'production' && TEST_USER_CONFIG) {
		return TEST_USER_CONFIG.Account
	}
	return ''
}

/**
 * 获取用户公司信息
 * @returns {Object} 包含 CompanyCode 和 CompanyName 的对象
 */
export function getUserCompany() {
	const accountInfo = getAccountInfo()
	if (accountInfo) {
		return {
			CompanyCode: accountInfo.userCompanyCode || accountInfo.CompanyCode || '',
			CompanyName: accountInfo.userCompanyName || accountInfo.CompanyName || ''
		}
	}
	// 如果使用测试用户配置，返回测试用户的公司信息
	if (process.env.NODE_ENV !== 'production' && TEST_USER_CONFIG && TEST_USER_CONFIG.CompanyCode) {
		return {
			CompanyCode: TEST_USER_CONFIG.CompanyCode || '',
			CompanyName: TEST_USER_CONFIG.CompanyName || ''
		}
	}
	return {
		CompanyCode: '',
		CompanyName: ''
	}
}

/**
 * 判断是否使用测试用户
 * @returns {boolean} 如果当前使用的是测试用户则返回true
 */
export function isUsingTestUser() {
	const accountInfo = getAccountInfo()
	if (!accountInfo) {
		// 如果没有登录信息，检查是否在使用测试用户
		return process.env.NODE_ENV !== 'production' && TEST_USER_CONFIG && TEST_USER_CONFIG.BookerID
	}
	// 如果已登录，检查是否使用的是测试用户的BookerID
	if (process.env.NODE_ENV !== 'production' && TEST_USER_CONFIG && TEST_USER_CONFIG.BookerID) {
		return getBookerID() === TEST_USER_CONFIG.BookerID
	}
	return false
}
//检查用户并登录
export function getLogin(returnurl) {
	// if(!checkLogin()){
	// 	router.push({
	// 		path: '/login',
	// 		query: {
	// 			logout: true,
	// 			returnurl: returnurl
	// 		}
	// 	});
	// 	return false;
	// }
	var loginurl=webconfig.yqfComApiurl+'/Account/JumpLogin?returnurl='+returnurl;
	window.location.href=loginurl;
}

export function getAccountCode() {
	const accountInfo = getUserInfo()
	return accountInfo?.Account || accountInfo?.useraccountno || TEST_USER_CONFIG.Account
}
//保存的唯一标识
export function getSessionKey() {
	var SessionKey = getStorage(YqfSessionKey);
	console.log(SessionKey);
	if (SessionKey == null || SessionKey == "") {
		SessionKey = newGuid();
		setStorage(YqfSessionKey, SessionKey);
		// uni.setStorage({
		// 	key: _yqfSessionKey,
		// 	data: SessionKey
		// })
	}
	console.log(SessionKey);
	return SessionKey;
}

//发送GET请求
export function getAjaxRequest(ajaxUrl, parm, callback) {
	ajaxGet(ajaxUrl, getParm(parm), function(result) {
		callback(result);
	})
}
//发送POST请求
export function postAjaxRequest(ajaxUrl, parm, callback) {
	ajaxPost(ajaxUrl, getParm(parm), function(result) {
		callback(result);
	})
}

function getParm(parm) {
	if (!isNullOrEmpty(parm)) {
		parm.yqfkey = getSessionKey();
		parm.time = Date.now();
		parm.mpid = mpid;
	} else {
		parm = {
			yqfkey: getSessionKey(),
			time: Date.now(),
			mpid: mpid
		};
	}
	
	// 使用统一的用户信息获取函数（支持测试用户fallback）
	const userInfo = getUserInfo()
	const userCompany = getUserCompany()
	
	// 设置用户账号（优先使用已有值，否则使用统一获取的值）
	if (isNullOrEmpty(parm.useraccountno)) {
		parm.useraccountno = getUserAccount()
	}
	
	// 设置公司信息（优先使用已有值，否则使用统一获取的值）
	if (isNullOrEmpty(parm.userCompanyCode)) {
		parm.userCompanyCode = userCompany.CompanyCode
		parm.userCompanyName = userCompany.CompanyName
	}
	if(userInfo!=null && userInfo!=undefined && userInfo!=''){
	// 设置角色ID
	parm.userRoleID = userInfo.userRoleID || userInfo.RoleID || 0
	parm.userOrganizaType = userInfo.userOrganizaType || userInfo.OrganizaType || 'INCU'
	parm.userBizAccount = userInfo.userBizAccount || userInfo.BizAccount || ''
	
	}
	parm.clientplatform = "PC";
	// console.log(parm);
	return parm;
}


//跳转支付
export function getPay(orderno, amount) {
	// 使用统一的用户账号获取函数（支持测试用户fallback）
	const PayLoginAccount = getUserAccount()
	let returnUrl=encodeURIComponent(webconfig.domainUrl + '/Profile/OrderDetail?id=' + orderno + '');
	let payUrl =
		'https://pay.yiqifei.com/pay/GetPay?PayMoney=' +
		amount +
		'&PayLoginAccount=' +
		PayLoginAccount +
		'&OrderId=' +
		orderno +
		'&returnurl=' + returnUrl;
	window.open(payUrl);
}

export function getCerTypeName(cerType) {
	switch (cerType) {
		//ID-身份证，PP-护照，NI-其他证件
		case 'ID':
			return '身份证';
		case 'PP':
			return '护照';
		case '10':
			return '军人证';
		case '11':
			return '回乡证';
		case '12':
			return '台胞证';
		case '13':
			return '港澳通行证';
		case 'NI':
			return '其他证件';
	}
	return cerType;
}
export function getInsuranceRoleName(InsuranceRole) {
	console.log(InsuranceRole);
	switch (InsuranceRole) {		
		case 1:
			return '投保人&被保人';
		case 2:
			return '投保人';
		case 3:
			return '被保人';		
	}
	return InsuranceRole;
}